import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Request } from 'karmadata';

import KdLoading from '../KdLoading';
import Popover from 'react-bootstrap/lib/Popover';

const propTypes = {
  theme: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired,
  onRemove: PropTypes.func,
  kdFilterModel: PropTypes.object.isRequired,
  api: PropTypes.shape({
    url: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

class KdPopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: false, popoverInfo: [] };
  }

  componentWillMount() {
    document.addEventListener('click', this.handleOutsideClick, false);
    this.setState({ isLoading: true });
    this.fetchItemInfo(this.props.label);
  }

  handleOutsideClick = (e) => {
    if (!ReactDOM.findDOMNode(this).contains(e.target)) {
      this.props.onRemove && this.props.onRemove();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  fetchItemInfo = (value) => {
    const { kdFilterModel, api } = this.props;
    if (value.length) {
      const onRequestDone = (data) => {
        this.setState({
          isLoading: false,
          popoverInfo: data.KdResult.Result[0],
        });
      };
      const request = Request(kdFilterModel.getEntityType(), 'Search');
      request.setUrlBase(api.url);
      request.setApiKey(api.key);
      request.setAjaxDone(onRequestDone);
      request.setQ(value);
      request.requestData();
    }
  }

  renderItemInfo = () => {
    const { popoverInfo } = this.state;
    const { theme } = this.props;
    const itemInfo = [];
    for (const key in popoverInfo) {
      if (popoverInfo.hasOwnProperty(key)) {
        itemInfo.push(
          <div
            key={key}
            className={classNames('c-kd-popover__details', theme['c-kd-popover__details'])}
          >
            <span className={classNames('c-kd-popover__label', theme['c-kd-popover__label'])}>{key}</span>
            <span className={classNames('c-kd-popover__value', theme['c-kd-popover__value'])}>{`${popoverInfo[key]}`}</span>
          </div>
        );
      }
    }
    return (
      <div className={classNames('c-kd-popover__body', theme['c-kd-popover__body'])}>
        {itemInfo}
      </div>
    );
  }

  render() {
    const { theme } = this.props;
    return (
      <div className={classNames('c-kd-popover', theme['c-kd-popover'])}>
        <Popover
          id="kd-popover"
          placement="top"
          className={classNames('c-kd-popover', theme['c-kd-popover'])}
          positionTop={-254}
          title={this.props.label}
        >
          {this.state.isLoading ? <KdLoading theme={theme} /> : this.renderItemInfo()}
        </Popover>
      </div>
    );
  }

}

KdPopover.propTypes = propTypes;
export default KdPopover;



// WEBPACK FOOTER //
// ./app/components/KdPopover/index.js